<template>
  <div class="row">
    <form-devolucion />
    <div class="col-xs-12 text-right q-pb-sm">
      <q-btn
        class="bg-pragma"
        icon="add"
        round
        flat
        @click="addDevolucion()"
      ></q-btn>
    </div>
    <div class="col-xs-12 text-center text-grey" v-if="devoluciones.length == 0">
      No se registraron devoluciones
    </div>
    <div class="col-xs-12" v-if="devoluciones.length > 0">
      <q-list bordered separator dark>
        <q-slide-item
          @right="opt => onRight(item.id, index, opt)"
          @left="opt => onLeft(item, opt)"
          right-color="negative"
          left-color="warning"
          v-for="(item, index) in devoluciones"
          :key="item.detalle"
          class="pragma-black"
        >
          <template v-slot:left>
            <q-icon name="visibility" />
          </template>
          <template v-slot:right>
            <q-icon name="clear" />
          </template>

          <q-item class="text-uppercase">
            <q-item-section>
              <q-item-label>{{item.detalle}}</q-item-label>
            </q-item-section>

            <q-item-section side top>
              <q-badge color="blue-grey" :label="`${item.cuenta.banco.nombre}`" />
              <q-item-label class="text-right text-caption q-pt-sm text-bold">{{item.cuenta.numero}}</q-item-label>
              <!-- <q-item-label class="text-right text-caption q-pt-sm text-bold">{{util.numberMoney(item.monto)}}</q-item-label>
              <q-item-label class="text-right text-caption q-pt-sm text-bold">{{item.comprobante}}</q-item-label> -->
            </q-item-section>
          </q-item>
        </q-slide-item>
      </q-list>
    </div>
    <div class="col-xs-12 q-pa-none">
      <hr>
    </div>
    <div class="col-xs-12">
      <q-input
        v-model="form.observacion"
        label="Observación"
        class="tu q-pt-sm"
        autogrow
        outlined
        dense
        label-color="grey"
        dark
      />
    </div>
    <div class="col-xs-12 text-center q-pt-sm">
      <q-btn
        color="positive"
        icon="send"
        label="Finalizar rendición"
        rounded
        :loading="loading"
        @click="rendir()"
      ></q-btn>
    </div>

    <!-- Dialog de eliminación -->
    <q-dialog
      v-model="delete_dev"
      style="max-width: 500px"
      persistent
      class="custom-font  text-uppercase"
    >
      <q-card class="full-width pragma-black text-white">
        <q-card-section class="q-pa-none text-white">
          <q-toolbar
            class="bg-pragma"
          >
            <span class="text-bold">Eliminar devolución</span>
            <q-space></q-space>
            <q-btn
              icon="clear"
              flat
              @click="delete_dev = false"
            ></q-btn>
          </q-toolbar>
        </q-card-section>
        <q-card-section class="text-center">
          ¿Está seguro/a que desea eliminar la devolución?
        </q-card-section>
        <q-card-actions>
          <div class="row full-width">
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                label="no"
                color="negative"
                icon="clear"
                class="full-width"
                @click="delete_dev = false"
              ></q-btn>
            </div>
            <div class="col-xs-6 q-pa-sm">
              <q-btn
                type="submit"
                label="sí"
                color="positive"
                icon="check"
                class="full-width"
                :loading="loading"
                @click="deleteDevolucion()"
              ></q-btn>
            </div>
          </div>
        </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Dialog de errores -->
    <q-dialog
      v-model="hasErrors"
      style="max-width: 500px"
      persistent
      class="custom-font text-uppercase"
    >
      <q-card class="full-width pragma-black text-white">
          <q-card-section class="q-pa-none text-white">
            <q-toolbar
              class="bg-pragma"
            >
              <span class="text-bold">Observaciones</span>
              <q-space></q-space>
              <q-btn
                icon="clear"
                flat
                @click="hasErrors = false"
              ></q-btn>
            </q-toolbar>
          </q-card-section>
          <q-card-section>
            <div class="row">
              <div class="col-xs-12">
                <ul>
                  <li v-for="error in errors" :key="error.message">{{error.message}}</li>
                </ul>
              </div>
            </div>
          </q-card-section>
          <q-card-actions>
            <div class="row full-width">
              <div class="col-xs-12 q-pa-sm">
                <q-btn
                  label="Cerrar"
                  icon="clear"
                  class="full-width bg-pragma"
                  @click="hasErrors = false"
                ></q-btn>
              </div>
            </div>
          </q-card-actions>
      </q-card>
    </q-dialog>

    <!-- Dialog de detalles de devolución -->
    <q-dialog
      class="custom-font text-uppercase"
      style="max-width: 500px"
      v-model="devolution_detail"
    >
      <q-card class="full-width pragma-black text-white">
          <q-card-section class="q-pa-none text-white">
            <q-toolbar
              class="bg-pragma"
            >
              <span class="text-bold">Devolución</span>
              <q-space></q-space>
              <q-btn
                icon="clear"
                flat
                @click="devolution_detail = false"
              ></q-btn>
            </q-toolbar>
          </q-card-section>
          <q-card-section>
            <div class="row q-gutter-y-sm">
              <div class="col-xs-12 text-white">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Banco
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{devolucion.cuenta.banco.nombre}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-12 text-white">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Nro. de cuenta
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{devolucion.cuenta.numero}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-12 text-white" v-if="devolucion.comprobante">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Comprobante
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{devolucion.comprobante}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-12 text-white">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Monto
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{util.numberMoney(devolucion.monto)}}
                  </q-card-section>
                </q-card>
              </div>
              <div class="col-xs-12 text-white">
                <q-card flat class="bg-grey-9">
                  <q-card-section class="text-caption q-pa-xs text-bold">
                    Detalle
                  </q-card-section>
                  <q-card-section class="q-pa-xs">
                    {{devolucion.detalle}}
                  </q-card-section>
                </q-card>
              </div>
            </div>
          </q-card-section>
          <q-card-actions>
            <div class="row full-width">
              <div class="col-xs-12 q-pa-sm">
                <q-btn
                  label="Cerrar"
                  icon="clear"
                  class="full-width bg-pragma"
                  @click="devolution_detail = false"
                ></q-btn>
              </div>
            </div>
          </q-card-actions>
      </q-card>
    </q-dialog>
  </div>
</template>

<script>
import { inject, ref } from 'vue'
import FormDevolucion from './FormDevolucion.vue'
import { useQuasar } from 'quasar'
import axios from 'axios'
import util from '../../../plugins/util'
import { useStore } from 'vuex'

export default {
  components: { FormDevolucion },
  props: ['devoluciones', 'solicitud', 'items'],
  setup (props) {
    // Variables del componente
    const bus = inject('bus')
    const $q = useQuasar()
    const store = useStore()

    const delete_dev = ref(false)
    const delete_id =  ref(null)
    const loading = ref(false)
    const form = ref({
      observacion: ''
    })
    const hasErrors = ref(false)
    const errors = ref([])
    const devolution_detail = ref(false)
    const devolucion = ref({})

    // Métodos y funciones
    const addDevolucion = () => {
      bus.emit('openDialogAddDevolucion', props.solicitud)
    }

    const deleteDevolucion = async () => {
      try {
        loading.value = true
        await axios.delete(`devolucion/${delete_id.value}`)
        $q.notify({
          message: 'Devolución eliminada',
          color: 'positive'
        })
        loading.value = false
        delete_dev.value = false
        delete_id.value = null
        bus.emit('refreshRendicion')
      } catch (error) {
        console.log(error)
        loading.value = false
      }
    }

    const onLeft = (item, {reset}) => {
      devolucion.value = item
      devolution_detail.value = true
      reset()
    }

    const onRight = (devolucion_id, index, {reset}) => {
      delete_dev.value = true
      delete_id.value = devolucion_id
      reset()
    }

    const rendir = async () => {
      try {
        loading.value = true
        if (validate()) {
          const user = store.getters['auth/user']
          if (user.global_view == 0) {
            const gestion = $q.localStorage.getItem('gestion')
            form.value.gestion_id = gestion.id
          }
          form.value.solicitud_id = props.solicitud.id
          form.value.platform = util.getPlatform()
          await axios.post('finalizar/solicitud/', form.value)
          $q.notify({
            message: 'Solicitud rendida',
            color: 'positive'
          })
          bus.emit('closeTabItems')
        }
        loading.value = false
      } catch (error) {
        console.log(error)
        loading.value = false
      }
    }

    const validate = () => {
      errors.value = []
      let message = ''
      if (props.items.length > 0) {
        message = `TODAVIA TIENE ${props.items.length} ITEM(S) PARA RENDIR, ELIMINELO(S) O RINDALO(S) PARA FINALIZAR LA RENDICIÓN`
        const data = {
          message
        }
        errors.value.push(data)
      }

      if (errors.value.length > 0) {
        hasErrors.value = true
        return false
      } else {
        return true
      }
    }

    // Template 
    return {
      onRight,
      onLeft,
      addDevolucion,
      delete_id,
      delete_dev,
      deleteDevolucion,
      loading,
      util,
      form,
      hasErrors,
      rendir,
      errors,
      devolution_detail,
      devolucion
    }
  }

}
</script>

<style>

</style>